import '../../App.scss';
import '../../css/modals.scss';
import {useTranslation} from 'react-i18next';
import React, {useEffect, useState, useRef, useContext} from 'react';
import Notification from '../Notification';
import BaseModal from './BaseModal';
import BaseForm from '../BaseForm';
import SubmitButton from '../SubmitButton';
import {BaseContext} from '../../helpers/common';
import { serverPost } from '../../helpers/server';
import {Container} from 'react-bootstrap';

const _ = require('lodash');

function PushToPartnerConfirmationModal(props) {
    const {getApiUrl} = useContext(BaseContext);
    const {t} = useTranslation('common');
    const [selectedBookings, setSelectedBookings] = useState([]);

    useEffect(() => {
        if (props.bookings) {
            setSelectedBookings(props.bookings)
        }
    }, [props.bookings]);

    const pushToPartner = (data) => {
        const pushData = {
            bookingIds: _.map(selectedBookings, b => b.id)
        }
        serverPost(getApiUrl("/bookings/push_to_partners"), pushData).then((res) => {
            if (res) {
                Notification.Show("Started pushing the bookings to LeagueApps.")
                props.onClose();
            }
        });
    }

    return (
        <>
            <BaseModal {...props}>
                <BaseForm onSubmit={pushToPartner}>
                    <BaseModal.Header>
                        <BaseModal.Title>Push to LeagueApps</BaseModal.Title>
                    </BaseModal.Header>
                    <BaseModal.Body>
                        <p>Are you sure you want to push these { selectedBookings.length } booking(s) to LeagueApps?</p>
                    </BaseModal.Body>
                    <BaseModal.Footer>
                        <Container>
                            <div className="d-flex flex-row justify-content-end">
                                <SubmitButton>Push</SubmitButton>
                            </div>
                        </Container>
                    </BaseModal.Footer>
                </BaseForm>
            </BaseModal>
        </>
    );
}

export default PushToPartnerConfirmationModal;
